import { useState } from 'react';
import axios from 'axios';

export default function TelegramDiagnostics() {
  const [webhookStatus, setWebhookStatus] = useState(null);
  const [webhookLoading, setWebhookLoading] = useState(false);
  const [webhookError, setWebhookError] = useState('');

  const [botStatus, setBotStatus] = useState(null);
  const [botLoading, setBotLoading] = useState(false);
  const [botError, setBotError] = useState('');

  const checkWebhook = () => {
    setWebhookLoading(true);
    setWebhookError('');
    axios.get('/api/telegram/webhook-info', { withCredentials: true })
      .then(r => setWebhookStatus(r.data))
      .catch(err => setWebhookError((err.response && err.response.data) || 'Помилка запиту'))
      .finally(() => setWebhookLoading(false));
  };

  const checkBot = () => {
    setBotLoading(true);
    setBotError('');
    axios.get('/api/telegram/status', { withCredentials: true })
      .then(r => setBotStatus(r.data))
      .catch(err => setBotError((err.response && err.response.data) || 'Помилка запиту'))
      .finally(() => setBotLoading(false));
  };

  const capabilities = (status) => {
    const list = [];
    if (status.canJoinGroups) list.push("приєднання до груп");
    if (status.canReadAllGroupMessages) list.push("читання групових повідомлень");
    if (status.supportsInlineQueries) list.push("inline-запити");
    return list.length > 0 ? list.join(', ') : '—';
  };

  return (
    <div className="conv-dashboard-section">
      <h4 className="conv-dashboard-section-title">Діагностика Telegram</h4>
      <div className="bot-diag-buttons">
        <button type="button" className="bot-diag-btn" onClick={checkWebhook} disabled={webhookLoading}>
          {webhookLoading ? 'Перевіряю...' : 'Перевірити вебхук'}
        </button>
        <button type="button" className="bot-diag-btn" onClick={checkBot} disabled={botLoading}>
          {botLoading ? 'Перевіряю...' : 'Перевірити бота'}
        </button>
      </div>

      {webhookError ? <p className="bot-diag-error">{webhookError}</p> : ''}
      {webhookStatus ? (
        <div className="bot-diag-result">
          <div className="bot-diag-row"><span>URL</span><span>{webhookStatus.url || '—'}</span></div>
          <div className="bot-diag-row"><span>Черга оновлень</span><span>{webhookStatus.pendingUpdateCount}</span></div>
          <div className="bot-diag-row"><span>Макс. з'єднань</span><span>{webhookStatus.maxConnections}</span></div>
          {webhookStatus.lastErrorMessage ? (
            <div className="bot-diag-row bot-diag-row-error">
              <span>Остання помилка</span>
              <span>{webhookStatus.lastErrorMessage} ({webhookStatus.lastErrorDate})</span>
            </div>
          ) : (
            <div className="bot-diag-row bot-diag-row-ok"><span>Помилок вебхука немає</span><span>✓</span></div>
          )}
        </div>
      ) : ''}

      {botError ? <p className="bot-diag-error">{botError}</p> : ''}
      {botStatus ? (
        <div className="bot-diag-result">
          <div className="bot-diag-row"><span>Бот</span><span>@{botStatus.username} ({botStatus.firstName})</span></div>
          <div className="bot-diag-row"><span>Можливості</span><span>{capabilities(botStatus)}</span></div>
          <div className={'bot-diag-row ' + (botStatus.commandsInSync ? 'bot-diag-row-ok' : 'bot-diag-row-error')}>
            <span>Команди</span>
            <span>
              {botStatus.commandsInSync
                ? 'синхронізовані ✓'
                : 'розбіжність: ' + (botStatus.liveCommands || []).join(', ') + ' (Telegram) vs ' + (botStatus.configuredCommands || []).join(', ') + ' (конфіг)'}
            </span>
          </div>
        </div>
      ) : ''}
    </div>
  );
}
